import HomeComponent from '../components/HomeComponent'
import Checkout from '../components/Checkout'
import order from '../components/order'
import Contact from '../components/Contact'
import privacypolicy from '../components/privacypolicy'
import termsandcondition from '../components/termsandcondition'
import refundcancellation from '../components/refundcancellation'
//import Home from '../components/Home'

const routes = [
 // {path: '/', component: Home, name: 'category' },
  {path: '/', component: HomeComponent, name: 'home' },
  {path: '/checkout', component: Checkout, name: 'Checkout'},
  {path: '/order', component: order, name: 'order'},
  {path: '/contact', component: Contact, name: 'contact'},
  {path: '/privacypolicy', component: privacypolicy, name: 'privacypolicy'},
  {path: '/termsandcondition', component: termsandcondition, name: 'termsandcondition'},
  {path: '/refundcancellation', component: refundcancellation, name: 'refundcancellation'}
]
export default routes;